var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-example-child md-example-child-md-activity-indicator md-example-child-md-activity-indicator-1"},[_c('md-activity-indicator',{attrs:{"type":"spinner","size":30,"text-size":14}},[_vm._v("加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }